import { DAYS, HOURS, MINUTES, SECONDS, PREFIX_WITHIN, PREFIX_IN } from './constants';
export function getTranslationKey(unit, isBusiness, isRange, prefix) {
    const prefixValue = `${prefix ? `${prefix}-` : ''}`;
    const isBusinessValue = `${isBusiness ? 'business-' : ''}`;
    const isRangeValue = `${isRange ? '-range' : ''}`;
    if (unit === SECONDS) {
        return `${prefix && prefix === PREFIX_IN ? `${prefixValue}${unit}` : unit}`;
    }
    if (unit === MINUTES) {
        return `${prefixValue}${unit}${isRangeValue}`;
    }
    if (unit === HOURS) {
        return `${prefixValue}${unit}${isRangeValue}`;
    }
    if (unit === DAYS) {
        return `${prefixValue}${isBusinessValue}${unit}${isRangeValue}`;
    }
    return 'unavailable';
}
export const availableTranslationKeysForDuration = [
    `${DAYS}`,
    `${PREFIX_IN}-${DAYS}`,
    `${DAYS}-range`,
    `${PREFIX_IN}-${DAYS}-range`,
    `business-${DAYS}`,
    `${PREFIX_IN}-business-${DAYS}`,
    `${PREFIX_WITHIN}-${DAYS}`,
    `${PREFIX_WITHIN}-business-${DAYS}`,
    `${PREFIX_IN}-business-${DAYS}-range`,
    `business-${DAYS}-range`,
    `${HOURS}`,
    `${PREFIX_WITHIN}-${HOURS}`,
    `${PREFIX_IN}-${HOURS}-range`,
    `${PREFIX_IN}-${HOURS}`,
    `${HOURS}-range`,
    `${MINUTES}`,
    `${PREFIX_WITHIN}-${MINUTES}`,
    `${PREFIX_IN}-${MINUTES}-range`,
    `${PREFIX_IN}-${MINUTES}`,
    `${MINUTES}-range`,
    `${SECONDS}`,
    `${PREFIX_IN}-${SECONDS}`,
];
